import { bool } from 'prop-types';
import React from 'react';

import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { associatedUserShape } from '../../prop-types';
import { withFullName } from '../utils';

function UserLink({ model, showIcon, showTeam, text, verbose, ...rest }) {
  const { fullName, id, sapId, team, email, salesUnit } = withFullName(model);
  const linkRef = React.useRef(null);
  const additionalContent = (
    <>
      {showTeam && <span className="pl-2 small">{team}</span>}
      {verbose && <span className="pl-2 small">{sapId}</span>}
    </>
  );

  return text ? (
    <span>
      {fullName}
      {additionalContent}
    </span>
  ) : (
    <>
      <span ref={linkRef}>
        <IconLink showIcon={showIcon} to={`/users/${id}/show`} {...rest}>
          {fullName}
        </IconLink>
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        title={fullName}
        fields={{
          Email: email,
          'Sales Unit': salesUnit,
          'SAP ID': sapId,
        }}
      />
    </>
  );
}

UserLink.propTypes = {
  model: associatedUserShape.isRequired,
  showIcon: bool,
  showTeam: bool,
  verbose: bool,
  text: bool,
};

UserLink.defaultProps = {
  showIcon: false,
  showTeam: false,
  verbose: false,
  text: false,
};

export default UserLink;
